"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SESSION = exports.CSRF_TOKEN = void 0;
exports.CSRF_TOKEN = '__ibrakadabra';
exports.SESSION = '__session';
//# sourceMappingURL=cookies.js.map